import React from 'react'
import ListItemContainer from '../../../../../../components/ListItemContainer'
import InfoBar from '../../../../../../modules/InfoBar'
import Hint from '../../../../../../modules/Hint'

const CowsList = ({ infoBar, cowslist, turnOffAlarms, sortCows }) => {
    return (
        <>
            {
                turnOffAlarms ?
                    <Hint
                        copy='Wybierz krowy, dla których chcesz czasowo wyłączyć powiadomienia alarmowe'
                    />
                    :
                    infoBar &&
                    <InfoBar
                        lastUpdate={infoBar.lastUpdate}
                        translation={infoBar.translation}
                        noContainer
                    />
            }
            <ListItemContainer
                data={cowslist && sortCows(cowslist.cows)}
                isEditMode={turnOffAlarms}
            />

        </>
    )
}

export default CowsList
